import React from 'react';

const InputBar = ({ prompt, setPrompt, handlePromptSubmit, handleBarcodeScan, handleGallery, handleCamera, fileInputRef, handleImageUpload, setShowScanHistory }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (prompt.trim()) {
      handlePromptSubmit(e);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="w-full">
      <div className="flex items-center bg-gradient-to-r from-emerald-50 to-teal-50 rounded-xl p-2 shadow-sm border border-emerald-200 hover:border-emerald-300 transition-all duration-200">
        <input
          type="text"
          value={prompt}
          onChange={e => setPrompt(e.target.value)}
          placeholder="What did you eat or exercise? (e.g., '1 boiled egg, 100g rice')"
          className="flex-1 bg-transparent border-none outline-none text-base placeholder-gray-500 px-1 py-1"
        />
        
        <div className="flex items-center space-x-1 ml-2">
          <button
            type="submit"
            className="p-2 rounded-lg bg-emerald-500 text-white hover:bg-emerald-600 transition-colors shadow-sm hover:shadow-md"
            title="Send Message"
          >
            <i className="bi bi-send text-sm"></i>
          </button>
          
          <button
            type="button"
            className="p-2 rounded-lg text-blue-600 hover:bg-blue-50 transition-colors"
            title="Scan Barcode"
            onClick={handleBarcodeScan}
          >
            <i className="bi bi-upc-scan text-sm"></i>
          </button>
          
          <button
            type="button"
            className="p-2 rounded-lg text-gray-600 hover:bg-gray-100 transition-colors"
            title="Scan History"
            onClick={() => setShowScanHistory(true)}
          >
            <i className="bi bi-clock-history text-sm"></i>
          </button>
          
          <button
            type="button"
            className="p-2 rounded-lg text-green-600 hover:bg-green-50 transition-colors"
            title="Upload Image"
            onClick={handleGallery}
          >
            <i className="bi bi-image text-sm"></i>
          </button>
          
          <button
            type="button"
            className="p-2 rounded-lg text-orange-600 hover:bg-orange-50 transition-colors"
            title="Take Photo"
            onClick={handleCamera}
          >
            <i className="bi bi-camera text-sm"></i>
          </button>
        </div>
          <input
          type="file"
          accept="image/jpeg,image/jpg,image/png,image/gif,image/webp,image/bmp"
          capture="environment"
          style={{ display: 'none' }}
          ref={fileInputRef}
          onChange={handleImageUpload}
        />
      </div>
    </form>
  );
};

export default InputBar;
